import React from "react";
import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import {
  LayoutDashboard, Boxes, Package, Tags, ClipboardList,
  Inbox, Settings, LogOut, ExternalLink,
} from "lucide-react";

const items = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/solutions", label: "Solutions", icon: Boxes },
  { to: "/admin/products", label: "Products", icon: Package },
  { to: "/admin/categories", label: "Categories", icon: Tags },
  { to: "/admin/orders", label: "Orders", icon: ClipboardList },
  { to: "/admin/leads", label: "Leads / RFQ", icon: Inbox },
  { to: "/admin/settings", label: "Settings", icon: Settings },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/admin/login");
  };

  return (
    <div className="min-h-screen bg-msr-surface flex">
      <aside className="hidden md:flex w-64 flex-col bg-msr-ink text-white border-r border-black/20" data-testid="admin-sidebar">
        <div className="px-4 py-5 border-b border-white/10 bg-white">
          <Link to="/admin" className="flex items-center">
            <img src="/brand/msr-logo.png" alt="MSR Business Solutions" className="h-10 w-auto object-contain" />
          </Link>
        </div>
        <div className="px-6 py-3 border-b border-white/10">
          <div className="text-[10px] uppercase tracking-[0.18em] text-white/60">Admin Console</div>
        </div>
        <nav className="flex-1 px-3 py-4">
          {items.map(({ to, label, icon: Icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              data-testid={`admin-nav-${label.toLowerCase().replace(/\s+/g, "-").replace("/", "-")}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-2.5 my-0.5 text-sm font-medium transition-colors ${
                  isActive ? "bg-msr-blue text-white" : "text-white/70 hover:text-white hover:bg-white/5"
                }`
              }
            >
              <Icon size={16} />
              {label}
            </NavLink>
          ))}
        </nav>
        <div className="px-3 py-4 border-t border-white/10 space-y-2">
          <Link to="/" target="_blank" className="flex items-center gap-2 px-4 py-2 text-xs text-white/60 hover:text-white" data-testid="admin-view-site-link">
            <ExternalLink size={14} /> View public site
          </Link>
          <div className="px-4 text-xs text-white/50 truncate">{user?.email}</div>
          <button onClick={handleLogout} className="w-full flex items-center gap-2 px-4 py-2 text-sm text-white/80 hover:text-white" data-testid="admin-logout-btn">
            <LogOut size={14} /> Log out
          </button>
        </div>
      </aside>
      <div className="flex-1 flex flex-col min-w-0">
        <div className="md:hidden bg-msr-ink text-white px-4 py-3 flex items-center justify-between">
          <div className="font-heading font-bold">MSR Admin</div>
          <button onClick={handleLogout} className="text-sm" data-testid="admin-logout-mobile-btn">Logout</button>
        </div>
        <main className="flex-1 p-6 lg:p-10">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
